import { useState } from 'react';

const useButtonsLoading = () => {
    const [isPrimaryButtonLoading, setIsPrimaryButtonLoading] = useState(false);

    const [isSecondaryButtonLoading, setIsSecondaryButtonLoading] = useState(false);

    return {
        isPrimaryButtonLoading,
        setIsPrimaryButtonLoading,
        isSecondaryButtonLoading,
        setIsSecondaryButtonLoading,
        areButtonsLoading: isPrimaryButtonLoading || isSecondaryButtonLoading
    };
};

export default useButtonsLoading;
